import { Component, inject, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { TermsAndConditionsDialogComponent } from '@booking-payments/payments/components/desktop/terms-and-conditions-dialog/terms-and-conditions-dialog.component';
import { Branding } from '@services/branding.service';
import { SafeHtmlPipe } from '@shared/pipes/safe-html.pipe';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [SafeHtmlPipe],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.css',
})
export class FooterComponent implements OnInit {
  logoUrl = '';
  footerHtml: string | null = null;
  isMobile = false;

  readonly dialog = inject(MatDialog);

  ngOnInit(): void {
    const branding = sessionStorage.getItem('branding');
    if (branding) {
      const parsed = JSON.parse(branding) as Branding;
      this.logoUrl = parsed.logo || '';
      this.footerHtml = parsed.footerHtml?.trim() || null;
    }
  }

  checkWindowWidth() {
    this.isMobile = window.innerWidth >= 1390;
  }

  openDialogMoreInfo(
    enterAnimationDuration: string,
    exitAnimationDuration: string
  ): void {
    this.dialog.open(TermsAndConditionsDialogComponent, {
      width: '512px',
      data: { isMobile: this.isMobile },
      enterAnimationDuration,
      exitAnimationDuration,
    });
  }
}
